// extracted by mini-css-extract-plugin
export default {"primaryColor":"#01ffff","primaryColorWithAlpha":"rgba(1,255,255,.1019607843)","mainBgColor":"#001519","secondBgColor":"#015f6b","secondaryColor":"#01262c"};